<div #iconSelect class="dropdown is-icon-select"
  [ngClass]="{ 'is-xlarge': isXLarge, 'is-large': isLarge, 'is-medium': isMedium, 'is-semi-transparent': isSemiTransparent }"
  [ngStyle]="{'width':  !!width ? width : null}">
  <div class="dropdown-trigger">
    <button type="button" class="button" aria-haspopup="true" [style.width]="!!width ? width + ' !important' : null"
      aria-controls="dropdown-menu2" (click)="showIconItemListClick(iconSelect)">
      <div fxLayout="row" fxLayoutAlign="space-between center" style="width:100%">
        <div fxLayout="row" fxLayoutAlign="start center">
          @if (!useTopoIcons && icon) {
            <div class="item-icon material-icons mr-1 dropdown-button" style="width: 30px">{{ icon }}</div>
          }
          @if (useTopoIcons && icon) {
            <div class="item-icon mr-1 dropdown-button" style="width: 30px">
              <i class="icon {{ icon }} item-icon"></i>
            </div>
          }
          <div class="item-name">{{ label }}</div>
        </div>
        <div>
          <span class="dropdown-button-arrow"></span>
        </div>
      </div>
    </button>
  </div>
  @if (isActive) {
    <div class="dropdown-menu" role="menu">
      <div class="dropdown-content">
        @for (item of items; track item.uId) {
          <div class="dropdown-item">
            <div fxLayout="row" fxLayoutAlign="space-between" class="icon-select-item is-large" (click)="selectIconItem(item)">
              <div fxLayout="row" fxLayoutAlign="start center">
                @if (!useTopoIcons && item.itemIcon) {
                  <div class="item-icon material-icons mr-1 dropdown-button" style="width: 30px">
                    {{ item.itemIcon }}
                  </div>
                }
                @if (useTopoIcons && item.itemIcon) {
                  <div class="item-icon mr-1 dropdown-button" style="width: 30px">
                    <i class="icon {{ item.itemIcon }}"></i>
                  </div>
                }
                <div class="item-name">{{ item.itemLabel }}</div>
              </div>
              @if (item.uId === selectedUId) {
                <div class="pr-5">
                  <span class="material-icons-outlined">done</span>
                </div>
              }
            </div>
          </div>
        }
      </div>
    </div>
  }
</div>
